module.exports = __webpack_public_path__ + "media/home3-right.48a0f82c.mp4";